export const SIDEBAR_LAYOUT_STORAGE_KEY = "tribunalea:suite-sidebar-layout";
const SIDEBAR_LAYOUT_COOKIE_KEY = "tribunalea_suite_sidebar_layout";
const SIDEBAR_LAYOUTS = new Set(["collapsible", "fixed"]);

export function defaultSidebarLayout(width) {
  return Number(width) < 1440 ? "collapsible" : "fixed";
}

function validSidebarLayout(value) {
  return SIDEBAR_LAYOUTS.has(value) ? value : null;
}

function cookieValue(cookie = "") {
  const entry = String(cookie)
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${SIDEBAR_LAYOUT_COOKIE_KEY}=`));
  if (!entry) return null;
  try {
    return validSidebarLayout(decodeURIComponent(entry.split("=").slice(1).join("=")));
  } catch {
    return null;
  }
}

export function readSidebarLayoutPreference({
  cookie = typeof document !== "undefined" ? document.cookie : "",
  storage = typeof window !== "undefined" ? window.localStorage : null,
} = {}) {
  const shared = cookieValue(cookie);
  if (shared) return shared;
  try {
    return validSidebarLayout(storage?.getItem(SIDEBAR_LAYOUT_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function persistSidebarLayoutPreference(layout, {
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
  storage = typeof window !== "undefined" ? window.localStorage : null,
} = {}) {
  const next = validSidebarLayout(layout);
  if (!next) return;
  try {
    storage?.setItem(SIDEBAR_LAYOUT_STORAGE_KEY, next);
  } catch {
    // Browsers can block local storage while still allowing the app to run.
  }
  if (typeof document === "undefined") return;
  const sharedDomain = hostname === "tribunalea.com"
    || hostname.endsWith(".tribunalea.com")
    ? "; Domain=.tribunalea.com"
    : "";
  document.cookie = `${SIDEBAR_LAYOUT_COOKIE_KEY}=${encodeURIComponent(next)}`
    + `; Path=/; Max-Age=31536000; SameSite=Lax${sharedDomain}`;
}
